import { GET_EVENTS_CAT_FETCH } from "../actionsTypes/categoriesTypes";

export const getEventsCatFetch = () => ({
  type: GET_EVENTS_CAT_FETCH,
});
